module.exports = __webpack_public_path__ + "static/img/lt-shop.b6f436d1.png";